var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.624 16.387A15.1 15.1 0 0 1 2.504 12a15.1 15.1 0 0 1 3.12-4.388C7.297 6.003 9.43 4.8 12 4.8s4.703 1.203 6.375 2.812A15.1 15.1 0 0 1 21.494 12a15.1 15.1 0 0 1-3.12 4.387C16.702 17.996 14.568 19.2 12 19.2s-4.702-1.204-6.375-2.813ZM12 20.4c5.94 0 9.675-5.6 10.8-8.4-1.125-2.802-4.86-8.4-10.8-8.4S2.324 9.198 1.2 12c1.125 2.8 4.86 8.4 10.8 8.4M8.4 12a3.6 3.6 0 1 1 7.2 0 3.6 3.6 0 0 1-7.2 0m8.4 0a4.8 4.8 0 1 0-9.6 0 4.8 4.8 0 0 0 9.6 0"
  })));
};
export default SvgEye;